var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 727.3 73.3",
    xmlSpace: "preserve",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g228",
    transform: "translate(0,4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 92.7,10.4 h 29.5 v 6.5 h -10.7 v 33.7 h -8.1 V 16.9 H 92.7 Z",
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 128.1,7.9 h 8.1 v 14.7 c 2.1,-2.7 5.6,-4.4 9.9,-4.4 7.2,0 12.5,4.8 12.5,13.7 v 18.7 h -8.1 V 33 c 0,-5.1 -2.8,-7.9 -7.1,-7.9 -4.4,0 -7.2,2.8 -7.2,7.9 v 17.6 h -8.1 z",
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 180.2,51.1 c -9.3,0 -16,-6.5 -16,-16.5 0,-10.1 6.6,-16.5 16,-16.5 9.2,0 15.7,6.3 15.7,15.8 0,1 -0.1,2.1 -0.2,3.1 h -23.3 c 0.4,4.7 3.6,7.4 7.7,7.4 3.5,0 5.4,-1.7 6.4,-3.9 h 8.7 c -1.8,5.9 -7.1,10.6 -15,10.6 z m -7.8,-19.5 h 15.2 c -0.1,-4.2 -3.5,-6.9 -7.6,-6.9 -3.9,0.1 -7,2.5 -7.6,6.9 z",
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 229.4,51 C 221,51 214.6,46.6 214.5,39 h 8.6 c 0.2,3.2 2.4,5.4 6.1,5.4 3.8,0 6.1,-2 6.1,-4.9 0,-8.7 -20.8,-3.5 -20.7,-18 0,-7.3 5.9,-11.6 14.2,-11.6 8.2,0 13.9,4.2 14.4,11.5 h -8.9 c -0.2,-2.7 -2.3,-4.7 -5.8,-4.8 -3.2,-0.1 -5.5,1.4 -5.5,4.7 0,8.1 20.6,3.6 20.6,17.8 0,6.2 -5,11.9 -14.2,11.9 z",
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 264.8,51.1 c -9.2,0 -16.2,-6.5 -16.2,-16.5 0,-10.1 7.2,-16.5 16.4,-16.5 9.2,0 16.4,6.4 16.4,16.5 0.1,10.1 -7.3,16.5 -16.6,16.5 z m 0,-7 c 4.3,0 8.4,-3.1 8.4,-9.5 0,-6.4 -4,-9.5 -8.2,-9.5 -4.2,0 -8.1,3.1 -8.1,9.5 -0.1,6.4 3.6,9.5 7.9,9.5 z",
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 309.8,33 c 0,-5.1 -2.8,-7.9 -7.1,-7.9 -4.4,0 -7.2,2.8 -7.2,7.9 v 17.6 h -8.1 V 18.7 h 8.1 v 4 c 2.1,-2.7 5.5,-4.4 9.6,-4.4 7.4,0 12.7,4.8 12.7,13.7 v 18.7 h -8.1 V 33 Z",
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 338,18.1 c 5,0 8.6,2.3 10.5,5.1 v -4.6 h 8.1 v 32.2 c 0,8.6 -5.3,15.5 -15.8,15.5 -9,0 -15.3,-4.5 -16.1,-11.8 h 8 c 0.8,2.9 3.8,4.8 7.8,4.8 4.4,0 7.9,-2.5 7.9,-8.5 v -5 c -1.9,2.8 -5.5,5.2 -10.5,5.2 -8.1,0 -14.6,-6.6 -14.6,-16.6 0,-10 6.6,-16.3 14.7,-16.3 z m 2.1,7.1 c -4.3,0 -8.4,3.2 -8.4,9.3 0,6.1 4.1,9.5 8.4,9.5 4.4,0 8.5,-3.3 8.5,-9.4 0,-6 -4.1,-9.4 -8.5,-9.4 z",
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 376.8,51.1 c -8,0 -13.6,-4.7 -14,-10.6 h 8.1 c 0.3,2.4 2.5,4.3 5.8,4.3 3.2,0 4.9,-1.4 4.9,-3.3 0,-5.7 -18,-2.1 -18,-13.8 0,-5.3 4.7,-9.6 12.6,-9.6 7.7,0 12.4,4.2 12.9,10.5 h -7.7 c -0.2,-2.5 -2.2,-4.1 -5.4,-4.1 -3,0 -4.6,1.2 -4.6,3.1 0,5.8 17.7,2.2 17.9,13.9 0.1,5.5 -4.7,9.6 -12.5,9.6 z",
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 417.8,10.4 v 33.8 h 13.3 v 6.4 H 409.8 V 10.4 Z",
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 448.7,18.1 c 5.1,0 8.6,2.4 10.5,5.1 v -4.6 h 8.1 v 31.9 h -8.1 v -4.7 c -1.9,2.8 -5.5,5.2 -10.6,5.2 -8.1,0 -14.5,-6.6 -14.5,-16.6 0,-10 6.5,-16.3 14.6,-16.3 z m 2.1,7.1 c -4.3,0 -8.4,3.2 -8.4,9.3 0,6.1 4.1,9.5 8.4,9.5 4.4,0 8.5,-3.3 8.5,-9.4 0,-6 -4.1,-9.4 -8.5,-9.4 z",
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 493.9,18.1 c 8.2,0 14.6,6.4 14.6,16.4 0,10 -6.4,16.6 -14.6,16.6 -5,0 -8.6,-2.3 -10.5,-5.1 v 4.6 h -8.1 V 7.9 h 8.1 v 15.4 c 1.9,-2.9 5.7,-5.2 10.5,-5.2 z m -2.1,7.1 c -4.3,0 -8.4,3.3 -8.4,9.4 0,6.1 4.1,9.4 8.4,9.4 4.4,0 8.5,-3.5 8.5,-9.5 0,-6 -4.1,-9.3 -8.5,-9.3 z",
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 528.6,51.1 c -9.2,0 -16.2,-6.5 -16.2,-16.5 0,-10.1 7.2,-16.5 16.4,-16.5 9.2,0 16.4,6.4 16.4,16.5 0,10.1 -7.4,16.5 -16.6,16.5 z m 0,-7 c 4.3,0 8.4,-3.1 8.4,-9.5 0,-6.4 -4,-9.5 -8.2,-9.5 -4.3,0 -8.1,3.1 -8.1,9.5 -0.2,6.4 3.5,9.5 7.9,9.5 z",
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 559.2,50.6 h -8.1 V 18.7 h 8.1 v 5 c 2,-3.3 5.4,-5.4 9.8,-5.4 v 8.5 h -2.1 c -4.8,0 -7.7,1.8 -7.7,8 z",
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 587,18.1 c 5.1,0 8.6,2.4 10.5,5.1 v -4.6 h 8.1 v 31.9 h -8.1 v -4.7 c -1.9,2.8 -5.5,5.2 -10.6,5.2 -8.1,0 -14.5,-6.6 -14.5,-16.6 0,-10 6.4,-16.3 14.6,-16.3 z m 2,7.1 c -4.3,0 -8.4,3.2 -8.4,9.3 0,6.1 4.1,9.5 8.4,9.5 4.4,0 8.5,-3.3 8.5,-9.4 0,-6 -4,-9.4 -8.5,-9.4 z",
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 614.8,25.3 H 611 v -6.6 h 3.8 v -7.9 h 8.1 v 7.9 h 7.1 v 6.6 h -7.1 v 15.4 c 0,2.1 0.9,3.1 3.4,3.1 h 3.7 v 6.8 h -5 c -6.1,0 -10.2,-2.6 -10.2,-9.9 z",
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 650.1,51.1 c -9.2,0 -16.2,-6.5 -16.2,-16.5 0,-10.1 7.2,-16.5 16.4,-16.5 9.2,0 16.4,6.4 16.4,16.5 0,10.1 -7.3,16.5 -16.6,16.5 z m 0,-7 c 4.3,0 8.4,-3.1 8.4,-9.5 0,-6.4 -4,-9.5 -8.2,-9.5 -4.3,0 -8.1,3.1 -8.1,9.5 -0.1,6.4 3.6,9.5 7.9,9.5 z",
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 680.8,50.6 h -8.1 V 18.7 h 8.1 v 5 c 2,-3.3 5.4,-5.4 9.8,-5.4 v 8.5 h -2.1 c -4.8,0 -7.7,1.8 -7.7,8 z",
    id: "path224"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 717.9,18.7 h 8.6 l -19.8,47 h -8.6 L 705,49.8 692.2,18.7 h 9.1 l 8.2,22.3 z",
    id: "path226"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.1,1C16.2,1,0,17.2,0,37.1C0,57,16.2,73.2,36.1,73.2C56,73.2,72.2,57,72.2,37.1C72.2,17.2,56,1,36.1,1z   M26.7,45.9h-3V28.1h3V45.9z M33.3,63.2h-3v-52h3V63.2z M40.2,56.9h-3V17.5h3V56.9z M47.3,52.5h-3V20.9h3V52.5z M54.2,41.6h-3v-9.4  h3V41.6z",
    id: "path230"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTsl);
export default __webpack_public_path__ + "static/media/logo-tsl.04823c8a92d087b9f894e59729de5540.svg";
export { ForwardRef as ReactComponent };